import { db, ensureFirebaseAuth } from "../db";
import * as THREE from "three";

function parseShrinkZoneData(data) {
  const position = new THREE.Vector2(
    ...data.position.split(",").map((x) => +x)
  );
  const shape = new THREE.Vector2(
    ...data.rectangleShape.split(",").map((x) => +x)
  );

  // console.log("position shape", position, shape);
  const startX = position.x - shape.x / 2;
  const endX = position.x + shape.x / 2;
  const startY = position.y - shape.y / 2;
  const endY = position.y + shape.y / 2;

  return {
    ...data,
    startX,
    endX,
    startY,
    endY,
  };
}

function isInZone(x, y, startX, endX, startY, endY) {
  return x >= startX && x <= endX && y >= startY && y <= endY;
}

export default class ShrinkZones {
  constructor() {
    this.shrinkZones = [];
  }

  async load() {
    await ensureFirebaseAuth();

    db.collection("shrinkZones").onSnapshot((querySnapshot) => {
      const shrinkZones = [];

      querySnapshot.forEach((doc) =>
        shrinkZones.push(parseShrinkZoneData(doc.data()))
      );

      this.shrinkZones = shrinkZones;
    });
  }

  getScale(position) {
    const { x, z: y } = position;

    const activeZones = this.shrinkZones.filter(({ active }) => active);

    for (let i = 0; i < activeZones.length; i++) {
      const { startX, endX, startY, endY, playerScale } = activeZones[i];
      // console.log(
      //   startX,
      //   endX,
      //   startY,
      //   endY,
      //   isInZone(x, y, startX, endX, startY, endY)
      // );
      if (isInZone(x, y, startX, endX, startY, endY)) {
        return playerScale;
      }
    }

    return 1;
  }
}
